import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as Theme from "../../../app/Theme";

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import * as rcc from "../NonVisual/RCConst";
import * as rcdu from "../NonVisual/RCDataUtil";

import GbStdTable from "../../common/GBStdTableAG/GbStdTable";

import * as gbtc from "../../GB/GBTableConst";
import * as gbtu from "../../GB/GBTableUtil";
import {
    cloneObj,
} from "../../GB/GBUtil";

import TListTable from "../../common/TListTable";
import {alignBtnsRight} from "../../common/TListBox";

const hiddenCol   = 0;
const indNameCol  = 1;
const numCols      = indNameCol + 1;

const colHeadingRow = 0;
const numHeaderRows = 1;

class RCCustomIndicatorForm extends Component {

    static propTypes = {

        indicatorObjList_D          : PropTypes.arrayOf(PropTypes.object),
        onIndicatorObjListChange_D  : PropTypes.func,

        selectedIndCurrID_D         : PropTypes.number,
        onSelectedIndicatorChange_D : PropTypes.func,
    };

    static defaultProps = {

        indicatorObjList_D         : {},
        onIndicatorObjListChange_D : () => console.log("onIndicatorObjListChange_D"),

        selectedIndCurrID_D         : 1,
        onSelectedIndicatorChange_D : () => console.log("onSelectedIndicatorChange_D"),

    };

    state = {

        firstRowIdx       : -1,
        finalRowIdx       : -1,
        tableRef          : React.createRef(),

    };

    onCustomIndPackTableChange = (newPackTable) => {

        try {

            const props = this.props;
            const indicatorObjList_D = cloneObj(props.indicatorObjList_D);

            let newIndName;
            let foundDifference = false;
            const value2DArray = gbtu.getPackTableValues(newPackTable);

            let r = 2; // start on 2 to skip header row
            let indNum = rcc.numDefIndicators + 1;
            if (value2DArray.length > 1) {

                while ((r <= value2DArray.length) && (!foundDifference)) {

                    newIndName = value2DArray[r - 1][indNameCol];
                    const oldIndName = rcdu.getIndName(indNum, indicatorObjList_D);

                    if (newIndName !== oldIndName) {

                        foundDifference = true;
                        rcdu.setIndName(indNum, indicatorObjList_D, newIndName);

                    }

                    r++;
                    indNum++;

                }

            }

            if (foundDifference) {

                props.onIndicatorObjListChange_D(indicatorObjList_D);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onIndListTableAddClick = () => {

        try {

            /* props */
            const props = this.props;
            const indicatorObjList_D = cloneObj(props.indicatorObjList_D);
            let selectedIndCurrID_D = props.selectedIndCurrID_D;

            selectedIndCurrID_D = rcdu.addIndicator(indicatorObjList_D, selectedIndCurrID_D);

            props.onIndicatorObjListChange_D(indicatorObjList_D, () => {

                props.onSelectedIndicatorChange_D(selectedIndCurrID_D);

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onIndListTableDeleteClick = () => {

        try {

            /* props */
            const props = this.props;
            const indicatorObjList_D = cloneObj(props.indicatorObjList_D);
            let selectedIndCurrID_D = props.selectedIndCurrID_D;

            /* state */
            const state = this.state;
            const firstRowIdx = state.firstRowIdx;
            const finalRowIdx = state.finalRowIdx;

            let indCurrID1DIntArray = [];

            for (let i = firstRowIdx; i <= finalRowIdx; i++) {

                indCurrID1DIntArray.push(i + rcc.numDefIndicators);

            }

            selectedIndCurrID_D = rcdu.deleteIndicators(indicatorObjList_D, indCurrID1DIntArray, selectedIndCurrID_D);

            props.onIndicatorObjListChange_D(indicatorObjList_D, () => {

                props.onSelectedIndicatorChange_D(selectedIndCurrID_D);

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onMoveArrowClick = (direction) => {

        try {

            /* props */
            const props = this.props;
            const indicatorObjList_D = cloneObj(props.indicatorObjList_D);

            /* state */
            const state = this.state;
            const firstRowIdx = state.firstRowIdx;
            const finalRowIdx = state.finalRowIdx;

            let indCurrID1DIntArray = [];

            for (let i = firstRowIdx; i <= finalRowIdx; i++) {

                indCurrID1DIntArray.push(i + rcc.numDefIndicators);

            }

            rcdu.moveIndicators(indicatorObjList_D, indCurrID1DIntArray, direction);

            props.onIndicatorObjListChange_D(indicatorObjList_D);

            // if (finalRowIdx === 2) {
            //     this.state.tableRef.current.addCellRange({
            //         rowStartIndex: 2,
            //         rowEndIndex  : 4,
            //         columnStart  : 'Indicator',
            //         columnEnd    : 'Indicator',
            //     });
            // }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onSelectCells = (cellRanges) => {

        try {

            /* Ag Grid makes a distinction between fixed rows and selectable rows. The row index
               will be with respect to the first selectable row. */
            if ((typeof cellRanges[0] !== "undefined") &&
                (typeof cellRanges[0].startRow !== "undefined") &&
                (typeof cellRanges[0].startRow.rowIndex !== "undefined") &&
                (typeof cellRanges[0].endRow !== "undefined") &&
                (typeof cellRanges[0].endRow.rowIndex !== "undefined")) {

                const startRowIdx = cellRanges[0].startRow.rowIndex;
                const endRowIdx = cellRanges[0].endRow.rowIndex;

                let firstRowIdx;
                let finalRowIdx;

                if (startRowIdx >= endRowIdx) {

                    finalRowIdx = startRowIdx;
                    firstRowIdx = endRowIdx;

                }
                else {

                    finalRowIdx = endRowIdx;
                    firstRowIdx = startRowIdx;

                }

                this.setState({

                    firstRowIdx : firstRowIdx + numHeaderRows,
                    finalRowIdx : finalRowIdx + numHeaderRows,

                });

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderCustomIndTable = () => {

        try {

            let table;

            const props = this.props;
            const indicatorObjList_D = props.indicatorObjList_D;

            const numCustomInd = rcdu.getNumCustomInd(indicatorObjList_D);
            const numRows = numCustomInd + 1;

            let packTable = gbtu.getNewPackTable();
            packTable = gbtu.resizePackTable(packTable, numCustomInd + 1, numCols);

            packTable = gbtu.setColWidth(packTable, hiddenCol, 0);
            packTable = gbtu.setColWidth(packTable, indNameCol, 400);

            packTable = gbtu.setWordWrappedCol(packTable, indNameCol, true);

            packTable = gbtu.setValue(packTable, colHeadingRow, indNameCol, RS(SC.GB_stIndicator));

            let indNum = rcc.numDefIndicators + 1;
            for (let r = 1; r <= numRows - 1; r++) {

                const indName = rcdu.getIndName(indNum, indicatorObjList_D);
                packTable = gbtu.setValue(packTable, r, indNameCol, indName);

                indNum++;

            }

            packTable = gbtu.setRowAlignment(packTable, colHeadingRow, gbtc.hAlign.center);
            packTable = gbtu.setMinAllowedValByCol(packTable, indNameCol, 0);
            packTable = gbtu.setMaxAllowedValByCol(packTable, indNameCol, 0);

            table =
                <GbStdTable
                    headerBackgroundColor = {Theme.RC_PalatinatePurple}
                    oddRowBackgroundColor = {Theme.RC_BandColor}
                    packTable             = {packTable}
                    onPackTableChanged    = {this.onCustomIndPackTableChange}
                    ref                   = {this.state.tableRef}
                    selectedRange         = {{
                        firstRow : this.state.firstRowIdx,
                        finalRow : this.state.finalRowIdx,
                    }}
                    onSelectCells         = {this.onSelectCells}
                    style                 = {{
                        width : 500,
                    }}
                />;

            return table;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    render() {

        const instructionsLab =
            <p
                style   = {{
                    color      : Theme.RC_HippieBlue,
                    fontWeight : "bold",
                    marginLeft : Theme.leftIndent,
                    marginTop  : Theme.topIndentFirstCtrl,
                }}
            >
                {RS(SC.GB_stEditIndInstruct)}
            </p>;


        const customIndTable = this.renderCustomIndTable();

        const buttons = {
            all : {
                style : {
                    backgroundColor : Theme.RC_HippieBlue,
                }
            },
            add : {
                caption : RS(SC.GB_stAddBtn),
                onClick : this.onIndListTableAddClick,
                title   : RS(SC.GB_stAddIndNote),
            },
            edit : {
                show : false,
            },
            delete : {
                caption : RS(SC.GB_stDeleteBtn),
                onClick : this.onIndListTableDeleteClick,
                show    : true,
                title   : RS(SC.GB_stRemoveIndNote),
            },
            up : {
                onClick : () => this.onMoveArrowClick(rcc.moveUp),
                show    : true,
                title   : RS(SC.GB_stMoveIndUpNote),
            },
            down : {
                onClick : () => this.onMoveArrowClick(rcc.moveDown),
                show    : true,
                title   : RS(SC.GB_stMoveIndDownNote),
            }
        };

        const customIndListTable =
            <TListTable
                buttonAlignment = {alignBtnsRight}
                buttons         = {buttons}
                maxTableHeight  = {500}
                style           = {{
                    marginLeft : Theme.leftIndent,
                    marginTop  : Theme.topIndent,
                }}
                table           = {customIndTable}
            />;

        return (

            <React.Fragment>

                {instructionsLab}
                {customIndListTable}

            </React.Fragment>

        );

    }

}

export default RCCustomIndicatorForm;
